define(["gsap","gsapScrollTrigger"],
    function ({ gsap },{ ScrollTrigger }) {
        var stickyHeader = {
            Init: function () {
                gsap.registerPlugin(ScrollTrigger);
                const header = document.querySelector(".score-header")
                if (header?.classList.contains("hidden-header")) {
                    ScrollTrigger.create({
                        trigger: header,
                        start: "bottom top", 
                        end: "max", 
                        onEnter: () => header.classList.add('stuck'), 
                        onLeaveBack: () => header.classList.remove('stuck'), 
                        markers: false 
                    });
                }
            }
        };
        return stickyHeader;
    } 
);